export default "__VITE_PUBLIC_ASSET__519ca755__"